// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"118":"2a12fe07","654":"8b4ec496","683":"7040477d","828":"2ac83c62"}[chunkId] + ".chunk.js";
};